import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import TrustStrip from './components/TrustStrip';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import CTASection from './components/CTASection';
import ArticlesGrid from './components/ArticlesGrid';
import TestimonialSection from './components/TestimonialSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://gtbuyspreadsheet.motorcycles';
const siteImage = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/54d75be42d5913aa14ca64dd22e5d1e3.jpeg';

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'GTBuy Spreadsheet Hub',
  url: siteUrl,
  description: 'Compare GTBuy Spreadsheet, Kakobuy Spreadsheet, and Superbuy Spreadsheet – the ultimate spreadsheet-based shopping systems. Find structured product data, buying guides, and optimized category navigation for smarter shopping decisions in 2026.',
  image: siteImage,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustStrip />
        <CategoryGrid />
        <AboutSection />
        <ComparisonSection />
        <CTASection />
        <ArticlesGrid />
        <TestimonialSection />
      </main>
      <Footer />
    </div>
  );
}